import React, { useState } from "react";
import { motion } from "framer-motion";
import "../../../programs.css";
import bgImage from "../../../Image/ice.png";
import ICEFAQ from "./ICEFAQ";
import ICECurriculum from "./ICECurriculum";
import Certificate from "../../Certificate";
import SkillPage from "../../SkillPage";
import ICEPricing from "./ICEPricing";
import { Link } from "react-router-dom";
export default function ICEPage() {
  const [form, setForm] = useState({
    fullName: "",
    email: "",
    phone: "",
    college: "",
    program: "IC Engine",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const scriptURL =
      "https://script.google.com/macros/s/AKfycbxpGr46MBF4HmNpxOYLbt2mQRcjEVPS5PtI1iZdXAMgIxORthvV4iD0Ev1zPEAsXZoK/exec";

    try {
      const res = await fetch(scriptURL, {
        method: "POST",
        body: JSON.stringify(form),
      });
      const data = await res.json().catch(() => ({}));
      if (data.status === "success" || res.ok) {
        alert("Application submitted successfully!");
        setForm({
          fullName: "",
          email: "",
          phone: "",
          college: "",
          program: "IC Engine",
        });
      } else {
        if (res.ok) {
          alert("Application submitted successfully!");
          setForm({
            fullName: "",
            email: "",
            phone: "",
            college: "",
            program: "IC Engine",
          });
        } else {
          console.error("Submit error:", data);
          alert("There was an error submitting the form. Try again later.");
        }
      }
    } catch (err) {
      console.error("Fetch error:", err);
      alert("Network error — please check your connection and try again.");
    }
  };

  return (
    <>
      <div className="webdev-bg" style={{ backgroundImage: `url(${bgImage})` }}>
        <div className="program-detail-main">
          <h1 className="program-detail-title">IC Engine</h1>
          <p className="program-detail-desc">
            An internal combustion engine turns fuel into motion. With
            controlled explosions, pistons move, power is delivered, and
            vehicles come alive. It mixes chemistry, mechanics, and precision to
            create the engines that transport people, goods, and dreams across
            the world.
          </p>
          <div className="program-detail-actions">
            <Link to="/register">
              <button className="register-btn">Register Now</button>
            </Link>
            <Link to="/contact-us">
              <button className="expert-btn">Talk To Expert</button>
            </Link>
          </div>
        </div>
      </div>

      {/* -------------------- NEW SECTION START -------------------- */}

      <div className="program-container">
        <motion.div
          className="program-left1"
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
        >
          <h2 className="program-heading1">Program Overview</h2>
          <p className="program-description1">
            Internal combustion engines are masterpieces of controlled energy.
            At Acadme, you explore how fuel-air mixtures ignite, how pistons
            convert pressure to rotation, and how torque is delivered through
            mechanical systems. You learn valve timing, lubrication, cooling
            cycles, emissions, and efficiency optimization. Training blends
            theory with hands-on experience—engine teardown, component study,
            sensor analysis, and performance diagnostics. During the internship,
            you engage in real automotive tasks: fault detection, testing
            parameters, analyzing engine behavior, and understanding industry
            workflows. You see how engineers solve overheating, vibration, and
            fuel challenges in real projects. If building engines that move the
            world excites you, enroll and unlock endless learning and
            opportunities at Acadme.
          </p>
        </motion.div>
        <motion.form
          className="program-form"
          initial={{ opacity: 0, x: 100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          onSubmit={handleSubmit}
        >
          <h3 className="form-title">Apply Now</h3>

          <div className="input-group">
            <label>
              <i className="fas fa-user"></i> Full Name
            </label>
            <input
              type="text"
              name="fullName"
              value={form.fullName}
              onChange={handleChange}
              placeholder="Your answer"
              required
            />
          </div>

          <div className="input-group">
            <label>
              <i className="fas fa-envelope"></i> Email Address
            </label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="Your answer"
              required
            />
          </div>

          <div className="input-group">
            <label>
              <i className="fas fa-phone"></i> Phone Number
            </label>
            <input
              type="text"
              name="phone"
              value={form.phone}
              onChange={handleChange}
              placeholder="+91 xxxxxxxxxx"
              maxLength="10"
              required
            />
          </div>

          <div className="input-group">
            <label>
              <i className="fas fa-university"></i> College Name
            </label>
            <input
              type="text"
              name="college"
              value={form.college}
              onChange={handleChange}
              placeholder="Your answer"
              required
            />
          </div>

          <div className="input-group">
            <label>
              <i className="fas fa-code"></i> Program
            </label>
            <input type="text" name="program" value={form.program} readOnly />
          </div>

          <button className="submit-btn" type="submit">
            Submit
          </button>
        </motion.form>
      </div>

      {/* -------------------- NEW SECTION END -------------------- */}

      <ICECurriculum />
      <SkillPage />
      <Certificate />
      <ICEPricing />
      <ICEFAQ />
    </>
  );
}
